<template>
  <v-layout pb-2>
    <v-flex xs12>
      <v-data-table
        :headers="headers"
        :items="documentosComprador"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <tr :class="claseSeccionValidacionDocumento(props.item, revisando || documentacionRechazada)">
            <td class="text-xs-left" :class="documentacionRechazada && props.item.validado === false ? 'error--text' : ''">{{ props.item.descripcionDocumento }}</td>
            <td class="text-xs-center">
              <v-layout justify-center align-center pa-0 ma-0>
                <img
                  v-if="props.item.mime.startsWith('image')"
                  :src="props.item.id ? $apiDocument(props.item) : props.item.documentoGrande"
                  :style="{ 'max-height':'70px' }"
                  :title="props.item.nombre"
                  class="py-1"
                />
                <div v-else>
                  {{props.item.nombre}}
                </div>
              </v-layout>
            </td>
            <td class="text-xs-right hidden-xs-only pr-2">
              <v-tooltip v-if="props.item.mime.startsWith('image')" bottom>
                <v-btn
                  icon slot="activator" 
                  class="smallTableButton" 
                  color="primary"
                  :disabled="guardando"
                  @click.stop="clickVerDocumento(props.item)"
                >
                  <v-icon>zoom_in</v-icon>
                </v-btn>
                <span style="text-transform:capitalize">{{$t('general.misc.ver')}}</span>
              </v-tooltip>
              <v-tooltip v-if="props.item.id" bottom>
                <v-btn
                  icon slot="activator" 
                  class="smallTableButton" 
                  color="primary"
                  :disabled="guardando"
                  @click.stop :href="$apiDocument(props.item)" target="_blank"
                >
                  <v-icon>file_download</v-icon>
                </v-btn>
                <span style="text-transform:capitalize">{{$t('general.misc.descargar')}}</span>
              </v-tooltip>
              <v-tooltip v-if="!revisando && !documentacionVer" bottom>
                <v-btn
                  icon slot="activator" 
                  class="smallTableButton"
                  color="primary"
                  :disabled="guardando"
                  @click.stop="clickEliminarDocumento(props.item)"
                >
                  <v-icon>
                    delete
                  </v-icon>
                </v-btn>
                <span>{{$t('general.misc.eliminar')}}</span>
              </v-tooltip>
              <v-tooltip v-else-if="revisando && !props.item.validado" bottom>
                <v-btn
                  icon slot="activator" 
                  class="smallTableButton"
                  color="green"
                  :disabled="guardando"
                  @click.stop="validarDocumento(props.item, true)"
                >
                  <v-icon color="white">
                    mdi-check
                  </v-icon>
                </v-btn>
                <span>{{$t('reservas.documentacion.validarDoc')}}</span>
              </v-tooltip>
              <v-tooltip v-else-if="revisando" bottom>
                <v-btn
                  icon slot="activator" 
                  class="smallTableButton"
                  color="red"
                  :disabled="guardando"
                  @click.stop="validarDocumento(props.item, false)"
                >
                  <v-icon color="white">
                    mdi-close
                  </v-icon>
                </v-btn>
                <span>{{$t('reservas.documentacion.rechazarDoc')}}</span>
              </v-tooltip>
            </td>
            <td class="text-xs-right hidden-sm-and-up pr-2">
              <v-layout align-center justify-end>
                <v-tooltip v-if="revisando && !props.item.validado" bottom>
                  <v-btn
                    icon slot="activator" 
                    class="smallTableButton mr-1"
                    color="green"
                    :disabled="guardando"
                    @click.stop="validarDocumento(props.item, true)"
                  >
                    <v-icon color="white">
                      mdi-check
                    </v-icon>
                  </v-btn>
                  <span>{{$t('reservas.documentacion.validarDoc')}}</span>
                </v-tooltip>
                <v-tooltip v-else-if="revisando" bottom>
                  <v-btn
                    icon slot="activator" 
                    class="smallTableButton mr-1"
                    color="red"
                    :disabled="guardando"
                    @click.stop="validarDocumento(props.item, false)"
                  >
                    <v-icon color="white">
                      mdi-close
                    </v-icon>
                  </v-btn>
                  <span>{{$t('reservas.documentacion.rechazarDoc')}}</span>
                </v-tooltip>
                <v-menu
                  transition="scale-transition" 
                  origin="top right"
                  offset-y left @click.native.stop
                  :disabled="guardando"
                >
                  <v-btn
                    flat icon
                    slot="activator" 
                    class="smallTableButton"
                  >
                    <v-icon color="primary">
                      more_vert
                    </v-icon>
                  </v-btn>
                  <v-list dense>
                    <v-list-tile v-if="props.item.mime.startsWith('image')" @click.stop="clickVerDocumento(props.item)">
                      <v-list-tile-action>
                        <v-icon color="primary">zoom_in</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title style="text-transform:capitalize">
                          {{$t('general.misc.ver')}}
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile v-if="props.item.id" @click.stop="clickDescargarDocumento(props.item)">
                      <v-list-tile-action>
                        <v-icon color="primary">file_download</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title style="text-transform:capitalize">
                          {{$t('general.misc.descargar')}}
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile v-if="!documentacionVer && !revisando" @click.stop="clickEliminarDocumento(props.item)">
                      <v-list-tile-action>
                        <v-icon color="primary">delete</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{$t('general.misc.eliminar')}}
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-layout>
            </td>
          </tr>
        </template>
        <template v-if="!revisando && !documentacionVer" slot="footer">
          <td :colspan="headers.length" class="px-0">
            <v-btn
              @click="openAddDocumentacion()"
              color="primary"
              large outline
              :style=" {'width': '100%', 'height': '70px', 'border-style': 'dashed' }"
              class="px-0 ma-0 mt-1"
              :disabled="guardando"
            >
              <v-layout justify-start align-center pa-3>
                <v-icon large class="custom-icon icon-add-page pr-2"/>
                <span>{{$t('promociones.addDocumento')}}</span>
              </v-layout>
            </v-btn>
          </td>
        </template>
        <template slot="no-data">
          <v-layout justify-center align-center class="error--text">
            {{$t('reservas.documentacion.avisoAddDocumentos')}}
          </v-layout>
        </template>
      </v-data-table>
    </v-flex>
    <v-fade-transition>
      <custom-dialog 
        v-if="mostrarSubirDocumentacion" 
        v-model="mostrarSubirDocumentacion"
        :cambiado="cambiadoSubirDocumentacion"
        @aceptar="mostrarSubirDocumentacion = $event"
      >
        <PopUpSubirDocumentacion
          :documentosSubidos="documentosComprador"
          @add="addNuevoDocumento($event)"
          @cambiado="cambiadoSubirDocumentacion = $event"
        />
      </custom-dialog>
    </v-fade-transition>
    <custom-dialog v-if="mostrarImagen" v-model="mostrarImagen">
      <v-container>
        <v-layout justify-center>
        <v-img 
          class="fullScreenCarousel"
          :src="imgShow.id ? $apiDocument(imgShow) : imgShow.documentoGrande"
          contain
        />
        </v-layout>
      </v-container>
    </custom-dialog>
    <v-fade-transition>
      <PopUpSeguro
        v-if="mostrarPopUpEliminar"
        @aceptar="eliminarDocumento($event)"
        :titulo="$t('reservas.documentacion.popupEliminarTitulo')"
        :pregunta="$t('reservas.documentacion.popupEliminarPregunta')"
        alerta=""
        :descartar="$t('general.misc.eliminar')"
        :cancelar="$t('general.popUpSeguro.cancelar')"
      />
    </v-fade-transition>
  </v-layout>
</template>
<script>
import rules from '@/mixins/rules'
import MixinComprador from '@/mixins/comprador'
import MixinDocumentacion from '@/mixins/documentacion'
import MixinEstadoDocumentacion from '@/mixins/estadosReserva/estadoDocumentacion'
import PopUpSubirDocumentacion from './PopUpSubirDocumentacion'
import PopUpSeguro from '@/components/generic/PopUpSeguro'
import { mapActions } from 'vuex'
export default {
  mixins: [rules, MixinComprador, MixinDocumentacion, MixinEstadoDocumentacion],
  components: { 
    PopUpSubirDocumentacion,
    PopUpSeguro
  },
  props: {
    comprador: {
      type: Object,
      required: true
    },
    guardando: {
      type: Boolean,
      default: false
    },
    revisando: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      documentosValidos: [],
      mostrarSubirDocumentacion: false,
      cambiadoSubirDocumentacion: false,
      mostrarImagen: false,
      mostrarPopUpEliminar: false,
      indexClick: 0
    }
  },
  created () {
    this.documentosValidos = this.documentacionFiltrada(this.comprador).map(() => true)
  },
  computed: {
    headers () {
      return !this.revisando ?
      [
        {
          text: this.$t('general.misc.descripcion'),
          value: 'descripcionDocumento',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('pages.incrustado.documento'),
          value: 'documento',
          align: 'center',
          sortable: false
        },
        {
          text: this.$t('general.misc.acciones'),
          align: 'right',
          sortable: false
        }
      ] :
      [
        {
          text: this.$t('general.misc.descripcion'),
          value: 'descripcionDocumento',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('pages.incrustado.documento'),
          value: 'documento',
          align: 'center',
          sortable: false
        },
        {
          text: this.$t('general.misc.acciones'),
          align: 'right',
          sortable: false
        }
      ]
    },
    imgShow () {
      return this.indexClick >= 0 ? this.documentosComprador[this.indexClick] : null
    },
    documentosComprador () {
      return this.comprador.documentacion[0].documento ? this.comprador.documentacion[0].documento : null
    }
  },
  methods: {
    ...mapActions({
      setAutoSave: 'documentacion/setAutoSave'
    }),
    comprobarDocumentacion () {
      let documentacionValidada = true
      if (!this.revisando && this.documentacionRechazada && this.comprador.documentacion[0].validado === false) {
        this.comprador.documentacion[0].documento.forEach(documento => {
          if (documento.validado === false) {
            documentacionValidada = false
          }
        })
      }
      return documentacionValidada && this.comprador.documentacion[0].documento.filter(x =>
          (x.id_temporal && x.status === 'SUCCESS') || x.id
        ).length > 0
    },
    clickVerDocumento (doc) {
      this.indexClick = this.documentosComprador.findIndex(x => x.descripcionDocumento === doc.descripcionDocumento)
      this.mostrarImagen = true
    },
    clickEliminarDocumento (doc) {
      this.indexClick = this.documentosComprador.findIndex(x => x.descripcionDocumento === doc.descripcionDocumento)
      this.mostrarPopUpEliminar = true
    },
    eliminarDocumento (eliminar) {
      this.mostrarPopUpEliminar = false
      if (eliminar) {
        if (this.$route.name.endsWith('simplificada')) {
          this.setAutoSave(true)
        }
        console.log()
        this.comprador.documentacion[0].documento.splice(this.indexClick, 1)
      }
    },
    openAddDocumentacion () {
      this.mostrarSubirDocumentacion = true
    },
    addNuevoDocumento (doc) {
      this.cambiadoSubirDocumentacion = false
      this.mostrarSubirDocumentacion = false
      this.comprador.documentacion[0].documento.push(doc)
    },
    validarDocumento (doc, validar) {
      let index = this.documentosComprador.findIndex(x => x.descripcionDocumento === doc.descripcionDocumento)
      this.comprador.documentacion[0].documento[index].validado = validar
    }
  },
  watch: {
    cambiadoSubirDocumentacion () {
      this.$emit('cambiado', this.cambiadoSubirDocumentacion)
    }
  }
}
</script>

<style lang="stylus" scoped>

  .fullScreenCarousel
    width:80vw;
    height:80vh;
    pointer-events: none;

</style>



// WEBPACK FOOTER //
// src/components/reservas/documentacion/DocumentacionFlexible.vue